angular.module('app').directive('apDesktopRuler', [
    function () {
        'use strict';
        return {
            restrict: 'E',
            templateUrl: '/app/partials/desktopRuler/views/apDesktopRuler.html',
            scope: true,
            transclude: false,
            link: function () {

                function onLoad() {
                }

                onLoad();
            }
        };
    }]);